<template>
  <v-card
    class="mx-auto cardOverflow"
    max-width="1440"
    tile
  >
    <div class="diaryHeader-wrapper">
      <div class="diaryHeaderSlide-wrapper">
        <v-btn width="75" height="64" @click="changeView()">
          <v-img
              max-width="50"
              :src="require('@/assets/img/icons/breakfast.png')"
              >
            </v-img>
        </v-btn>
        <h3 class="text-center">Alumno</h3>
      </div>
      <baby-diary-header @changedColumn="catchColumnChanges"  />
    </div>
    <div class="diaryBody-wapper">
      <div class="diaryStudent-wrapper">
        <div ref="studentName" class="student diary-row" v-for="(item, i) in diaryData" :key="version+i">
          <p>{{item.name}}</p>
        </div>
      </div>
      <div class="diaryRow-wrapper">
        <baby-diary-row class="diary-row" ref="diaryRow" v-for="(item, i) in diaryData"
          :key="version+i" :pos="i" :id="item.id" :student="item"
          @enableStudent="enableStudent" @updatedStudent="catchChanges"/>
      </div>
    </div>
  </v-card>
</template>

<script>
import CardHeader from '@/components/Elements/CardHeader.vue'
import BabyDiaryRow from './BabyDiaryRow.vue'
import BabyDiaryHeader from './BabyDiaryHeader.vue'
export default {
  components: { CardHeader, BabyDiaryRow, BabyDiaryHeader },
  props: {
    classId: {
      type: String,
      default: () => ''
    },
    students: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    diaryData: function () {
      this.version = new Date().getTime()
      return this.students
    }
  },
  data: () => ({
    version: new Date().getTime(),
    selectedItem: 1,
    selectedClass: undefined
  }),
  methods: {
    changeView: function () {
      this.$router.push({ name: 'menuForm', params: {classId: this.classId} })
    },
    showClassroom: function (classId) {
      this.$router.go(-1)
    },
    catchChanges: function (newVersion) {
      console.log({newVersion})
      this.$emit('updatedStudent', newVersion)
    },
    enableStudent: function ({id, state}) {
      const elem = this.$refs.studentName[id]
      state ? elem.classList.remove('disabled') : elem.classList.add('disabled')
    },
    catchColumnChanges: function (columnValue) {
      console.log({columnValue})
      this.$refs.diaryRow.forEach(row => row.updateColumn(columnValue))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryType/BabyDiary/index.vue